<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay scrollable transition="dialog-bottom-transition">
    <v-card tile :loading="isLoading">
      <dialog-toolbar
        :document="document"
        @closeDialog="dialog = false"
      />
      <v-card-text class="pa-0 mt-1">
        <v-data-table
          v-if="!isLoading"
          :mobile-breakpoint="0"
          :headers="headers"
          hide-default-footer
          :items="records"
          :search="search"
        ></v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentApi from 'app/document/api'
import dialogToolbar from './dialogToolbar'

export default {
  name: 'document',
  components: {
    dialogToolbar
  },
  data () {
    return {
      dialog: false,
      document: {},
      isLoading: false,
      search: '',
      headers: [
        {
          text: '№',
          align: 'right',
          value: 'id',
          width: 80
        },
        {
          text: 'Товар',
          align: 'left',
          value: 'name'
        },
        {
          text: 'К-во',
          align: 'right',
          value: 'quantity',
          width: 80
        }
      ],
      records: []
    }
  },
  methods: {
    async open (document) {
      this.document = document
      this.dialog = true
      await this.loadData()
    },
    async loadData () {
      this.isLoading = true
      try {
        let response = await DocumentApi.getDocument(this.document.doc_id, this.document.name)
        this.records = response.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
